exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-custom[data-v-ed0678c6]{max-width:800px}ul.credentials-list[data-v-ed0678c6]{margin:0;padding:0;list-style-type:none}ul.credentials-list li[data-v-ed0678c6]{width:100%}div.new-credentials[data-v-ed0678c6]{margin:2em 0}.v-password input[data-v-ed0678c6],input.conferma_password[data-v-ed0678c6],input.email[data-v-ed0678c6],input.username[data-v-ed0678c6]{padding:10px 5px;width:100%;border:1px solid grey}.addresses ul.vs__dropdown-menu[data-v-ed0678c6]{width:100%;max-width:100%}", ""]);

// exports
